import React from 'react';
import { motion } from 'framer-motion';
import { Leaf, Wind, ShieldCheck, Activity, Heart, Carrot, CheckCircle2 } from 'lucide-react';
export function ProductExplanation() {
  const ingredients = [{
    icon: <Wind className="w-6 h-6 text-forest" data-id="element-130" />,
    title: 'Inulin & Topinambur',
    desc: 'Präbiotika die schlechte Bakterien verdrängen und Gasbildung reduzieren'
  }, {
    icon: <Activity className="w-6 h-6 text-forest" data-id="element-131" />,
    title: 'Johannisbrotmehl',
    desc: 'Reguliert Darmbewegung und reduziert Gärungsprozesse'
  }, {
    icon: <ShieldCheck className="w-6 h-6 text-forest" data-id="element-132" />,
    title: 'Leinsamen',
    desc: 'Bilden eine schützende Schleimschicht, beruhigt den Darm'
  }, {
    icon: <Heart className="w-6 h-6 text-forest" data-id="element-133" />,
    title: 'Artischocke',
    desc: 'Fördert den Gallenfluss und verbessert die Fettverdauung'
  }, {
    icon: <Leaf className="w-6 h-6 text-forest" data-id="element-134" />,
    title: 'Mariendistel',
    desc: 'Unterstützt die Leber, die bei der Verdauung eine zentrale Rolle spielt'
  }, {
    icon: <Carrot className="w-6 h-6 text-forest" data-id="element-135" />,
    title: 'Möhrenmehl',
    desc: 'Liefert natürliches Pektin, das den Darm reguliert'
  }];
  return <section className="w-full px-4 py-16 max-w-5xl mx-auto" data-id="element-136">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} className="text-center mb-12" data-id="element-137">
        <h2 className="font-handwriting text-4xl md:text-5xl text-forest font-bold mb-4" data-id="element-138">
          Warum Blähungen entstehen – und was wirklich hilft
        </h2>
        <p className="font-serif text-lg text-gray-700 max-w-2xl mx-auto" data-id="element-139">
          Eine unausgeglichene Darmflora ist die Hauptursache von Blähungen bei
          Hunden. Hier setzt die natürliche Kraft pflanzlicher Inhaltsstoffe an.
        </p>
      </motion.div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-140">
        {ingredients.map((item, index) => <motion.div key={index} initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: index * 0.1
      }} className="bg-white p-6 rounded-xl shadow-sm border border-brown/10 flex flex-col items-start gap-4 hover:shadow-md transition-shadow" data-id="element-141">
            <div className="p-3 bg-cream rounded-full" data-id="element-142">{item.icon}</div>
            <div data-id="element-143">
              <h4 className="font-serif font-bold text-gray-900 mb-2" data-id="element-144">
                {item.title}
              </h4>
              <p className="font-serif text-gray-600 text-sm leading-relaxed" data-id="element-145">
                {item.desc}
              </p>
            </div>
          </motion.div>)}
      </div>

      <motion.div initial={{
      opacity: 0
    }} whileInView={{
      opacity: 1
    }} viewport={{
      once: true
    }} className="mt-10 flex items-center justify-center gap-2 text-forest font-serif font-medium bg-forest/5 py-4 rounded-lg" data-id="element-146">
        <CheckCircle2 className="w-5 h-5" data-id="element-147" />
        <span data-id="element-148">100% pflanzlich, keine künstlichen Zusätze</span>
      </motion.div>
    </section>;
}